<template>
    <div>
        <div>
            <span class="module-title">Cheltuieli eligibile</span>
            <div class="scrollList">
                <ul class="mt-2">
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Dotări (utilaje, echipamente tehnologice)</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Echipamente informatice</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Mijloace de transport auto - Clasa 2.3.2 (electrice sau hibride)</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Instalaţii/ echipamente specifice în scopul obţinerii unei economii de energie</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Cheltuielile de consultanță</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Cheltuieli cu activitățile obligatorii de publicitate și informare</li>
                    <li><b-icon-check-circle-fill class="eligibil mr-2"></b-icon-check-circle-fill>Activele necorporale</li>
                </ul>
            </div>
            <span class="module-title mt-4">Cheltuieli neeligibile</span>
            <div class="scrollList">
                <ul class="mt-2">
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>TVA DEDUCTIBIL</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Investiții pentru sedii de birouri și birouri administrative</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Cheltuielile salariale</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Achizițiile de echipamente second-hand</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Achiziții în regim de leasing</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Cheltuieli cu auditul final</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Cheltuieli cu externalizarea serviciilor GDPR</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Achiziția de clădiri / spații de producție</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Construcţii şi instalaţii</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Cheltuieli pentru investiţia de bază sau investiții demarate</li>
                    <li><b-icon-x-circle-fill class="neeligibil mr-2"></b-icon-x-circle-fill>Cheltuieli notariale</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {BIconCheckCircleFill, BIconXCircleFill} from 'bootstrap-vue'

    export default{
        components: {
            BIconCheckCircleFill,
            BIconXCircleFill,
        },
    }
</script>

<style scoped>
.green {
    color: #59b395;
}
.white-box{
    background: #ffffff;
    padding: 15px;
}
.white-box li{
    font-size: 12px;
    color: #5b607a;
    line-height: 23px;
    font-weight: 500;
}
.module-title{
    font-weight: 600;
    font-size: 14px;
}
.scrollList{
    max-height: 350px;
    overflow: auto;
}
.white-box ul{
    padding: 0;
    list-style: none;
}
.eligibil{
    font-weight: 700 !important;
    color: #46cca6 !important;
}
.neeligibil{
  font-weight: 700 !important;
  color: #ff6767 !important;
}
</style>
